import { reactive, computed } from 'vue';

const ERROR_CODES = {
	TELEPHONE_NUMBER_FORMAT_ERROR: 936,
	APPOINTMENT_LIMIT_REACHED: 940
};

const backendErrors = reactive({
	email: false,
	phone: false
});

const backendMessage = reactive({
	email: null,
	phone: null
});

export const useErrors = () => {
	const getBackendErrors = () => backendErrors;
	const getBackendMessage = () => backendMessage;
	const setError = (errorCode, msg) => {
		if (errorCode == ERROR_CODES.TELEPHONE_NUMBER_FORMAT_ERROR) {
			backendErrors.phone = true;
			backendMessage.phone = msg;
		} else if (errorCode == ERROR_CODES.APPOINTMENT_LIMIT_REACHED) {
			backendErrors.email = true;
			backendMessage.email = msg;
		}
	};
	const resetError = (error) => {
		backendErrors[error] = false;
	};
	const resetAll = () => {
		Object.keys(backendErrors).forEach((error) => (backendErrors[error] = null));
		Object.keys(backendMessage).forEach((error) => (backendMessage[error] = null));
	};
	const hasBackendError = computed(() => Object.values(backendErrors).some((error) => error == true));
	return {
		getBackendErrors,
		getBackendMessage,
		setError,
		resetError,
		resetAll,
		hasBackendError
	};
};
